import { Type } from "../utils/type";
import { Maybe, maybe } from "./Maybe";

export const Domain = Type("Domain", {
  id: Number,
  remoteID: Maybe,
  host: String
});

export const makeDomain = (id, domain) =>
  Domain(id, maybe(domain.id), domain.end_host);

export const serializeDomain = domain => domain.host;
